import { useBoolean } from '@aibees/shared/hooks';
import { memo } from 'react';
import { SearchTableHeaderButton } from '../search-table-header-button';
import { SearchPayloadDialog } from './search-payload-dialog';

/**
 * Header button that opens the Search Payload dialog. The dialog is mounted only
 * while open so it snapshots the current search params fresh on each open (and
 * never subscribes to the params store — see the header perf contract).
 */
export const SearchPayloadButton = memo(
  ({ compact }: { compact?: boolean }) => {
    const state = useBoolean(false);

    return (
      <>
        <SearchTableHeaderButton
          text="Search Payload"
          icon="code-outline"
          variant="text"
          color="default"
          compact={compact}
          onClick={state.onTrue}
        />
        {state.value && <SearchPayloadDialog state={state} />}
      </>
    );
  }
);

SearchPayloadButton.displayName = 'SearchPayloadButton';
